
import common from './common.json';
import discovery from './discovery.json';
import footer from './footer.json';
import homepageNew from './homepage-new.json';
import ev from './ev.json';
import fm from './fm.json';

import casestudyLift from './casestudy-lift.json';

export default {
  ...common,
  ...footer,
  ...homepageNew,
  discovery,
  ev,
  fm,
  ...casestudyLift
};
